import axios from "axios";

const SSO_URL = "https://sso.erdenetmc.mn";
const EOFFICE_URL = "https://office.erdenetmc.mn/api/eoffice";
const DIGITAL_URL = "https://digital.erdenetmc.mn";
const DB_URL = "http://dbservice.erdenetmc.mn:8081/logincontrol/api/portal";

export const all = axios.all;
export const spread = axios.spread;

export function SSO() {
  return createInstance(SSO_URL);
}

export function EOFFICE() {
  return createInstance(EOFFICE_URL);
}
export function DIGITALEMC() {
  return createInstance(DIGITAL_URL);
}

export function DB() {
  return createInstance(DB_URL);
}

const createInstance = (baseURL) => {
  const headers = {
    "Content-Type": "application/json,",
  };
  // const token =
  //   typeof window !== "undefined"
  //     ? localStorage.getItem("eoffice_token")
  //     : null;
  // if (token != null) {
  //   Object.assign(headers, {
  //     Authorization: "SSO " + token,
  //   });
  // }

  let api = axios.create({
    baseURL: baseURL,
    timeout: 200000,
    headers,
  });

  // api.interceptors.response.use(
  //   (response) => response,
  //   (error) => {
  //     if (error.message !== "Network Error") {
  //       if (error.response.status === 401) {
  //         Swal.fire({
  //           title: "",
  //           text: "Токений хугацаа дууссан байна та дахин нэвтэрнэ үү!",
  //           icon: "warning",
  //           showCancelButton: true,
  //           confirmButtonColor: "#1890ff",
  //           cancelButtonColor: "rgb(244, 106, 106)",
  //           confirmButtonText: "Нэвтрэх",
  //           cancelButtonText: "Хаах",
  //         }).then((result) => {
  //           if (result.isConfirmed) {
  //             localStorage.removeItem("eoffice_token");
  //             window.location.reload();
  //           }
  //         });
  //       } else {
  //         throw error;
  //       }
  //     } else {
  //       Swal.fire("", "Сервис дээр алдаа гарлаа.", "error");
  //       throw error;
  //     }
  //   }
  // );
  return api;
};

export async function getMenu() {
  const response = await DIGITALEMC().get("/api/sites");
  return response;
}

// Хэрэглэгчийн хувийн мэдээлэл
export async function getUserInfo() {
  const response = await EOFFICE().get("/general/userinfo");
  return response;
}

export async function downloadFile(id) {
  const response = await EOFFICE().get("/general/downloadfile/" + id, {
    responseType: "blob",
  });
  const file = new Blob([response.data]);
  let fileUrl = URL.createObjectURL(file);
  return fileUrl;
}

// Жагсаалт
export async function getDocList(type, params) {
  const response = await EOFFICE().get("/document/" + type, {
    params: {
      ...params,
    },
  });
  return response;
}
// Doc Develop Type
export async function getDevelopType(type, id) {
  const response = await EOFFICE().get("/general/" + type + "/" + id);
  return response;
}

export async function getDevelopSendUser() {
  const response = await EOFFICE().get("logincontrolapi/group/axx");
  return response;
}
export async function postDevelopWorkers(type, developID, params) {
  const response = await EOFFICE().post(
    "/document/develop/" + developID + "/" + type,
    {
      ...params,
    }
  );
  return response;
}

export async function deleteDevelopWorkers(type, id) {
  const response = await EOFFICE().delete(
    "/document/develop/" + id + "/" + type
  );
  return response;
}
export async function getDevelopWorkers(searchText) {
  const response = await EOFFICE().get("/general/workers/" + searchText);
  return response;
}
export async function getDevelopWorkersRoles(id, params) {
  const response = await EOFFICE().get("/document/develop/roles/" + id, {
    params: {
      ...params,
    },
  });
  return response;
}

export async function getDevelop(DevelopID) {
  const response = await EOFFICE().get(
    "/document/develop/" + DevelopID + "/details"
  );
  return response;
}
export async function postDevelop(params) {
  const response = await EOFFICE().post("/document/develop", {
    ...params,
  });
  return response;
}
export async function putDevelop(DevelopID, params) {
  const response = await EOFFICE().post(
    "/document/develop/" + DevelopID + "/details",
    {
      ...params,
    }
  );
  return response;
}
export async function postDevelopFile(DevelopID, formData) {
  const response = await EOFFICE().post(
    "document/develop/" + DevelopID,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response;
}
export async function deleteDevelop(DevelopID, type) {
  const response = await EOFFICE().delete(
    "document/develop/" + DevelopID + "/" + type
  );
  return response;
}

// HELPS

export async function getHelpsList(type, id) {
  const response = await DIGITALEMC().get("/api/softwarefiles");
  return response;
}

export async function getHelpsListDetail(id) {
  const response = await DIGITALEMC().get("/api/softwarefiles/" + id);
  return response;
}

export async function getHelpsFile(id, pid) {
  const response = await DIGITALEMC().get(
    "/api/softwarefiles/" + pid + "/download/" + id,
    {
      responseType: "blob",
    }
  );

  return response;
}
